import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainApp from './MainApp';
import AdminApp from './admin/AdminApp';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/admin/*' element={<AdminApp />} />
        <Route path='/*'       element={<MainApp />} />
      </Routes>
    </BrowserRouter>
  );
}


